/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function EditIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.99878 21.0013H6.74878L17.8088 9.94128L14.0588 6.19128L2.99878 17.2513V21.0013ZM4.99878 18.0813L14.0588 9.02128L14.9788 9.94128L5.91878 19.0013H4.99878V18.0813Z" fill="currentColor" />

      <path d="M18.3688 3.29128C17.9788 2.90128 17.3488 2.90128 16.9588 3.29128L15.1288 5.12128L18.8788 8.87128L20.7088 7.04128C21.0988 6.65128 21.0988 6.02128 20.7088 5.63128L18.3688 3.29128Z" fill="currentColor" />
    </SvgIcon>
  );
}
